import React from "react";
import ShopnowBanner from "./shopnowbanner"
import PromotionTag from '../../../assets/images/PromotionTag.png'

const ShopnowBannerContainer = (props: any) => {


    const headingMsg = <div>Our advertisements and promotions have moved. Click <span className="quickmanangelink" onClick={props.PromotionViewAll} onKeyDown={() => { }}>View all</span> to access</div>
    const sliderlist: any = [
        {
            key: 1,
            heading: headingMsg,
            img: PromotionTag,
        }
    ];

    return (
        <ShopnowBanner sliderlist={sliderlist} />
    );
};

export default ShopnowBannerContainer;
